import { createSlice } from "@reduxjs/toolkit";
import { buscarSaldoInicioContaBanco } from "../../../services/saldoInicioContaBancoService";
import { resetAll } from "../../actions/actions";
import { SaldoInicioContaBancoModel } from "../../../models/contaBanco/saldoInicioContaBancoModel";

export interface SaldoInicioContaBancoState {
  //buscar saldo inicio conta banco
  loading: boolean;
  busca: number | null;
  list: SaldoInicioContaBancoModel[];
  entity: SaldoInicioContaBancoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: SaldoInicioContaBancoState = {
  //buscar saldo inicio conta banco

  loading: false,
  busca: null,
  list: [],
  entity: {} as SaldoInicioContaBancoModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const saldoInicioContaBancoSlice = createSlice({
  name: "saldoInicioContaBanco",
  initialState,
  reducers: {
    //buscar saldo inicio conta banco
    setBuscaSaldoInicioContaBanco: (state, action) => {
      state.busca = action.payload;
    },
    setEntitySaldoInicioContaBanco: (state, action) => {
      state.entity = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);
    //buscar saldo inicio conta banco
    builder.addCase(buscarSaldoInicioContaBanco.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarSaldoInicioContaBanco.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarSaldoInicioContaBanco.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar saldo inicio conta banco
  setBuscaSaldoInicioContaBanco,
  setEntitySaldoInicioContaBanco,
} = saldoInicioContaBancoSlice.actions;

export default saldoInicioContaBancoSlice.reducer;
